import { useReceipts } from '@/hooks/queries';
import { useAuth } from '@/hooks/useAuth';
import { formatNumber } from '@/lib/format';

interface RejectedSalesAlertProps {
  onShowRejected: () => void;
  onShowPending: () => void;
}

/**
 * Para o membro: as vendas reprovadas na conferência (fora do vendido até ele
 * corrigir) e as que estão em análise (ainda não contam). Some quando não há
 * nenhuma — e para o administrador, que vê tudo nos comprovantes.
 */
export function RejectedSalesAlert({ onShowRejected, onShowPending }: RejectedSalesAlertProps) {
  const { isAdmin } = useAuth();
  const rejected = useReceipts({ review: 'rejected', period: 'all', page: 1, pageSize: 1 }, { enabled: !isAdmin }).data?.total ?? 0;
  const pending = useReceipts({ review: 'pending', period: 'all', page: 1, pageSize: 1 }, { enabled: !isAdmin }).data?.total ?? 0;
  if (isAdmin) return null;

  return (
    <>
      {rejected > 0 ? (
        <div className="alert alert-error pending-deposits" role="status">
          <span>
            <strong className="num">{formatNumber(rejected)}</strong> {rejected === 1 ? 'venda foi reprovada' : 'vendas foram reprovadas'} na
            conferência. Abra, veja o motivo e corrija: o comprovante volta para a análise.
          </span>
          <button type="button" className="btn btn-sm" onClick={onShowRejected}>Ver o motivo</button>
        </div>
      ) : null}
      {pending > 0 ? (
        <div className="alert alert-info pending-deposits" role="status">
          <span>
            <strong className="num">{formatNumber(pending)}</strong> {pending === 1 ? 'venda está' : 'vendas estão'} em análise e ainda não{' '}
            {pending === 1 ? 'conta' : 'contam'}: não achamos a compra no checkout com o mesmo cliente e valor. Confira se o cliente está no comprovante.
          </span>
          <button type="button" className="btn btn-sm" onClick={onShowPending}>Ver</button>
        </div>
      ) : null}
    </>
  );
}
